var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.evento.statusId != 2 && _vm.acao.codSituacao != 1)?_c('span',{staticClass:"text-danger float-left mr-1"},[_c('i',{staticClass:"fa fa-ban fa-lg icon-button",attrs:{"title":"Cancelar Evento"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarCancelar(_vm.evento.idEvento)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }